import classnames from 'classnames';
import styles from './Figure.module.css';

export interface IFigureProps {
    alt: string;
    centered?: boolean;
    className?: string;
    fixedSquareSizes?: 'is16X16' | 'is24X24' | 'is32X32' | 'is48X48' | 'is64X64' | 'is96X96' | 'is128X128';
    imageUrl: string;
    imgClassName?: string;
}
export function Figure(props: IFigureProps) {
    return (
        <figure className={classnames(styles.figure, props.className || '')}>
            <img
                alt={props.alt}
                className={classnames(
                    styles.image,
                    props.imgClassName || '',
                    props.centered ? styles.centered : '',
                    props.fixedSquareSizes ? styles[props.fixedSquareSizes] : ''
                )}
                src={props.imageUrl}
            />
        </figure>
    );
}
